import {
  businessErrorMessage,
  BusinessErrors,
  BusinessErrorTypes,
} from '@tv2-player/common-utils/businessErrors';
import type { NormalizedError } from '../types';
import messages from '../config/messages';
import { NormalizedErrorWithFatal } from './error';

/**
 * Looks at the error to find the appropriate message.
 * @param {NormalizedError} error Error object.
 * @return {{ header: string; message: string;}} Error message.
 */
export function getErrorMessage(error: NormalizedError): {
  header: string;
  theme: string;
  message: string;
} {
  switch (error.type) {
    case ERROR_TYPES.REFRESH_TOKEN:
    case ERROR_TYPES.INVALID_AUTH_TOKEN:
    case ERROR_TYPES.UNAUTHENTICATED:
      return messages.LOGIN(error);
    case ERROR_TYPES.LICENSE_NOT_GRANTED:
      return messages.SUBSCRIPTION(error);
    case ERROR_TYPES.CONCURRENCY_LIMIT_VIOLATION:
      return messages.CONCURRENCY(error);
    case ERROR_TYPES.GEO_LOCATION_BLOCKED:
      return messages.GEOBLOCKED(error);
    case ERROR_TYPES.HTTP_ERROR:
    case ERROR_TYPES.DOES_NOT_EXISTS:
    case ERROR_TYPES.FORMAT_NOT_AVAILABLE:
    case ERROR_TYPES.NO_DOWN_LOADURL:
    case ERROR_TYPES.NO_FILES:
    case ERROR_TYPES.NO_PUBLIC_URLS:
    case ERROR_TYPES.NO_STREAMING_URL:
    case ERROR_TYPES.NOT_APPROVED:
    case ERROR_TYPES.NOT_AVAILABLE_RESTRICTION:
    case ERROR_TYPES.NOT_YET_AVAILABLE:
    case ERROR_TYPES.NOT_YET_AVAILABLE_RESTRICTION:
    case ERROR_TYPES.NOT_AVAILABLE:
    case ERROR_TYPES.EXPIRED:
    case ERROR_TYPES.EXPIRED_RESTRICTION:
    case ERROR_TYPES.EMPTY_PLAYBACK:
      return messages.NOT_AVAILABLE(error);
    case ERROR_TYPES.DEVICE_NOT_GRANTED:
      return messages.DEVICE_NOT_GRANTED(error);
    case ERROR_TYPES.SUBTITLE_ERROR:
      return messages.SUBTITLE_ERROR(error);
    case ERROR_TYPES.DUPLICATE_LIVE_STREAM_VIOLATION:
      return messages.DUPLICATE_LIVE_STREAM_VIOLATION(error);
    default:
      return messages.UNKNOWN(error);
  }
}
export const ERROR_TYPES = {
  INVALID_AUTH_TOKEN: 'InvalidAuthToken',
  UNAUTHENTICATED: 'UNAUTHENTICATED',
  UNHANDLE_REJECTION: 'unhandledrejection',
  LOAD_FAILED: 'load_failed',
  ERROR: 'error',
  REFRESH_TOKEN: 'RefreshToken',
  HTTP_ERROR: 'HttpError',
  LICENSE_NOT_GRANTED: 'LicenseNotGranted',
  DOES_NOT_EXISTS: 'DoesNotExist',
  FORMAT_NOT_AVAILABLE: 'FormatNotAvailable',
  NO_DOWN_LOADURL: 'NoDownloadUrl',
  NO_FILES: 'NoFiles',
  NO_PUBLIC_URLS: 'NoPublicUrls',
  NO_STREAMING_URL: 'NoStreamingUrl',
  NOT_APPROVED: 'NotApproved',
  NOT_AVAILABLE: 'NotAvailable',
  NOT_AVAILABLE_RESTRICTION: 'NotAvailableRestriction',
  NOT_YET_AVAILABLE: 'NotYetAvailable',
  NOT_YET_AVAILABLE_RESTRICTION: 'NotYetAvailableRestriction',
  EXPIRED: 'Expired',
  EXPIRED_RESTRICTION: 'ExpiredRestriction',
  GEO_LOCATION_BLOCKED: 'GeoLocationBlocked',
  CONCURRENCY_LIMIT_VIOLATION: 'ConcurrencyLimitViolation',
  DUPLICATE_LIVE_STREAM_VIOLATION: 'DuplicateLiveStreamViolation',
  INVALID_REGION: 'InvalidRegion',
  SCRIPT_LOAD_ERROR: 'ScriptLoadError',
  SUBTITLE_ERROR: 'SubtitleError',
  EMPTY_PLAYBACK: 'EmptyPlayback',
  DOWNSTREAM_SERVICE_ERROR: 'DOWNSTREAM_SERVICE_ERROR',
  GRAPHQL_VALIDATION_FAILED: 'GRAPHQL_VALIDATION_FAILED',
  GRAPHQL_GENERIC_ERROR: 'GraphQLError',
  UNKNOWN: 'Unknown',
  DEVICE_NOT_GRANTED: 'DeviceNotGranted',
};

export function mapBusinessErrorTypeToMessage(errorType: NormalizedErrorWithFatal['type']) {
  if (BusinessErrors.includes(errorType as BusinessErrorTypes)) {
    return businessErrorMessage(errorType as BusinessErrorTypes);
  }

  return false;
}
